const commandList = [
	{
		key: 'quickCommand',
		win: ['/'],
		mac: ['/'],
	},
	{
		key: 'mention',
		win: ['@'],
		mac: ['@'],
	},
	{
		key: 'emoji',
		win: ['meta', '.'],
		mac: ['ctrl', 'command', 'space'],
	},
	{
		key: 'uploadImage',
		win: ['shift', 'ctrl', 'I'],
		mac: ['shift', 'command', 'I'],
	},
	{
		key: 'uploadFile',
		win: ['shift', 'ctrl', 'E'],
		mac: ['shift', 'command', 'E'],
	},
	{
		key: 'setHr',
		win: ['---'],
		mac: ['---'],
	},
	{
		key: 'setBold',
		win: ['ctrl', 'B'],
		mac: ['command', 'B'],
	},
	{
		key: 'setItalic',
		win: ['ctrl', 'I'],
		mac: ['command', 'I'],
	},
	{
		key: 'setLink',
		// win: ['ctrl', 'K'],
		// mac: ['command', 'K'],
		win: [],
		mac: [],
	},
	{
		key: 'setCode',
		win: ['ctrl', 'E'],
		mac: ['command', 'E'],
	},
	{
		key: 'setHighlight',
		// win: ['shift', 'ctrl', 'H'],
		// mac: ['shift', 'command', 'H'],
		win: [],
		mac: [],
	},
	{
		key: 'setStrikedThrough',
		// win: ['shift', 'ctrl', 'X'],
		// mac: ['shift', 'command', 'X'],
		win: [],
		mac: [],
	},
	{
		key: 'setParagraph',
		win: ['ctrl', '1'],
		mac: ['option', 'command', '0'],
	},
	{
		key: 'setH2',
		// win: ['ctrl', '1'],
		// mac: ['option', 'command', '1'],
		win: [],
		mac: [],
	},
	{
		key: 'setH3',
		// win: ['ctrl', '2'],
		// mac: ['option', 'command', '2'],
		win: [],
		mac: [],
	},
	{
		key: 'setCodeBlock',
		// win: ['ctrl', '4'],
		// mac: ['option', 'command', '4'],
		win: [],
		mac: [],
	},
	{
		key: 'setUnorderedList',
		// win: ['ctrl', '5'],
		// mac: ['option', 'command', '5'],
		win: [],
		mac: [],
	},
	{
		key: 'setOrderedList',
		// win: ['ctrl', '6'],
		// mac: ['option', 'command', '6'],
		win: [],
		mac: [],
	},
	{
		key: 'setCheckList',
		// win: ['ctrl', '7'],
		// mac: ['option', 'command', '7'],
		win: [],
		mac: [],
	},
	{
		key: 'setHint',
		// win: ['ctrl', '8'],
		// mac: ['option', 'command', '8'],
		win: [],
		mac: [],
	},
	{
		key: 'setBlockquote',
		// win: ['ctrl', '9'],
		// mac: ['option', 'command', '9'],
		win: [],
		mac: [],
	},
	{
		key: 'undo',
		win: ['ctrl', 'Z'],
		mac: ['command', 'Z'],
	},
	{
		key: 'redo',
		win: ['shift', 'ctrl', 'Z'],
		mac: ['shift', 'command', 'Z'],
	},
	{
		key: 'indent',
		win: ['tab'],
		mac: ['tab'],
	},
	{
		key: 'unindent',
		win: ['shift', 'tab'],
		mac: ['shift', 'tab'],
	},
	{
		key: 'moveUp',
		win: ['shift', 'ctrl', 'up'],
		mac: ['shift', 'command', 'up'],
	},
	{
		key: 'moveDown',
		win: ['shift', 'ctrl', 'down'],
		mac: ['shift', 'command', 'down'],
	},
	{
		key: 'createEntry',
		win: ['alt', 'N'],
		mac: ['option', 'N'],
	},
	{
		key: 'search',
		win: ['alt', 'F'],
		mac: ['option', 'F'],
	},
	{
		key: 'toggleSidebar',
		win: ['alt', 'P'],
		mac: ['option', 'P'],
	},
	{
		key: 'openShortcutModal',
		win: ['alt', 'H'],
		mac: ['option', 'H'],
	},
	{
		key: 'save',
		win: ['ctrl', 'alt', 'S'],
		mac: ['command', 'S'],
	},
]

export default commandList
